// Product description from Shopify: a story paragraph plus lines like "<emoji> Title: detail".
// Split it so the feature lines can show first (big icon, bold title) and the story below it.
function ptSplitDesc(html){
  const box=document.createElement('div');box.innerHTML=String(html||'').replace(/<br\s*\/?>/gi,'\n');
  const feats=[],story=[];
  const line=/^\s*((?:\p{Extended_Pictographic}|\p{Emoji_Presentation})[\uFE0F\u200D\p{Extended_Pictographic}]*)\s*([^:]{2,48}):\s*(.+)$/u;
  const blocks=box.querySelectorAll('p,li').length?[...box.querySelectorAll('p,li')].map(e=>e.textContent):[box.textContent];
  blocks.forEach(b=>b.split('\n').map(t=>t.trim()).filter(Boolean).forEach(t=>{const m=t.match(line);if(m)feats.push({icon:m[1],title:m[2].trim(),text:m[3].trim()});else story.push(t);}));
  return{feats,story};
}
function PtProductDetails({html}){
  const{feats,story}=React.useMemo(()=>ptSplitDesc(html),[html]);
  const[more,setMore]=React.useState(false);
  const long=story.join(' ').length>220;
  if(!feats.length&&!story.length)return null;
  return React.createElement('div',{className:'pd-details'},
    feats.length>0&&React.createElement('ul',{className:'pd-feats'},feats.map((f,k)=>React.createElement('li',{key:k,className:'pd-feat'},
      React.createElement('span',{className:'pd-feat-icon','aria-hidden':'true'},f.icon),
      React.createElement('span',{className:'pd-feat-copy'},React.createElement('strong',null,f.title),React.createElement('span',null,f.text))))),
    story.length>0&&React.createElement('div',{className:'pd-story'+(long&&!more?' is-clamped':'')},story.map((t,k)=>React.createElement('p',{key:k},t))),
    long&&React.createElement('button',{type:'button',className:'pd-more',onClick:()=>setMore(m=>!m)},more?'Show less':'Read more'));
}

// Size guide pop-up. The chart comes from the product's "Size chart" field in Shopify
// (pawtherapy.size_chart), one row per line with | between columns, first line = headings:
//   Size | Neck | Chest | Weight
//   S | 20-28 cm | 30-40 cm | 2-5 kg
// Without a chart it still shows how to measure and a quick way to ask us.
function ptParseChart(txt){
  const rows=String(txt||'').split(/\r?\n/).map(r=>r.trim()).filter(r=>r.includes('|')).map(r=>r.replace(/^\||\|$/g,'').split('|').map(c=>c.trim()));
  return rows.length>1?{head:rows[0],body:rows.slice(1)}:null;
}
function PtSizeHelp({product,onClose}){
  const chart=ptParseChart(product.sizeChart);
  const wa=typeof ptWaUrl==='function'?ptWaUrl():'';
  const ask=wa?wa+'?text='+encodeURIComponent('Hi thepawtherapy, please help me pick the right size for '+product.name+'. My pet is a ___ and weighs ___ kg.'):'';
  React.useEffect(()=>{const k=e=>{if(e.key==='Escape')onClose();};window.addEventListener('keydown',k);document.body.style.overflow='hidden';return()=>{window.removeEventListener('keydown',k);document.body.style.overflow='';};},[]);
  // The brand measuring guide (image), plus the same table as text for screen readers and search.
  const guide=(window.ASSET_BASE||'')+'size-guide.webp';
  const GUIDE=[['S','30\u201348 cm / 12\u201319 in','43\u201356 cm / 17\u201322 in'],['M','36\u201361 cm / 14\u201324 in','56\u201369 cm / 22\u201327 in'],['L','43\u201371 cm / 17\u201328 in','69\u201381 cm / 27\u201332 in'],['XL','51\u201384 cm / 20\u201333 in','81\u2013107 cm / 32\u201342 in']];
  return React.createElement('div',{className:'sz-overlay',onClick:onClose},
    React.createElement('div',{className:'sz-modal',role:'dialog','aria-modal':'true','aria-label':'Size guide',onClick:e=>e.stopPropagation()},
      React.createElement('div',{className:'sz-head'},
        React.createElement('h3',null,'Size guide'),
        React.createElement('button',{className:'icon-btn',onClick:onClose,'aria-label':'Close',autoFocus:true},React.createElement(Icon.X,null))),
      React.createElement('div',{className:'sz-body'},
        chart&&React.createElement('div',{className:'sz-table-wrap'},
          React.createElement('p',{className:'sz-for'},String(product.name)),
          React.createElement('table',{className:'sz-table'},
            React.createElement('thead',null,React.createElement('tr',null,chart.head.map((c,i)=>React.createElement('th',{key:i},c)))),
            React.createElement('tbody',null,chart.body.map((r,i)=>React.createElement('tr',{key:i},chart.head.map((_,j)=>React.createElement('td',{key:j},r[j]||''))))))),
        React.createElement('a',{className:'sz-guide',href:guide,target:'_blank',rel:'noopener',title:'Open full size'},
          React.createElement('img',{src:guide,width:1100,height:825,alt:'Harness measuring guide: measure the chest around the broadest part just behind the front legs, and the lower neck at the base of the neck. Between sizes, choose the larger size.'})),
        React.createElement('p',{className:'sz-zoom'},'Tap the guide to open it full size.'),
        React.createElement('table',{className:'visually-hidden'},React.createElement('caption',null,'Harness sizes (general guide)'),
          React.createElement('thead',null,React.createElement('tr',null,React.createElement('th',null,'Size'),React.createElement('th',null,'Lower neck'),React.createElement('th',null,'Chest girth'))),
          React.createElement('tbody',null,GUIDE.map(r=>React.createElement('tr',{key:r[0]},r.map((c,j)=>React.createElement('td',{key:j},c)))))),
        ask&&React.createElement('a',{className:'btn btn-outline sz-ask',href:ask,target:'_blank',rel:'noopener'},'Ask us on WhatsApp'))));
}

function PDPInner({id:rawId,category:f,onNav:n,onAdd:S}){
  const g=(rawId||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,'');
  const{CATEGORIES:w,PRODUCTS:d}=window.DATA;
  let a=null,i=f;
  // match by our id (title slug) or by the Shopify handle (product URLs where the two differ)
  for(const e of Object.keys(d)){const t=d[e].find(o=>o.id===g||o.handle===g);if(t){a=t,i=e;break}}
  if(!a)return React.createElement('div',{style:{padding:80,textAlign:'center'}},'Product not found.');

  // Shopify metafields can return rich-text objects instead of strings - force to string.
  const str=v=>v==null?'':typeof v==='object'?JSON.stringify(v):String(v);

  const c=w.find(e=>e.id===i)||{id:i,name:'Products'};
  // Variant selection: one chosen value per option; the matching variant sets price, stock and checkout id.
  const options=a.options||[],variants=a.variants||[];
  // Shown for any real option, even a single value (e.g. Size: "Free Size" appears selected).
  const hasOpts=options.length>0&&variants.length>0;
  const firstVar=variants.find(v=>v.available)||variants[0]||null;
  // Start on the colour the shopper came for: ?variant=<id> in the link (ads, shared links) or a
  // colour dot clicked on a product card. Falls back to the first in-stock variant.
  const[sel,setSel]=React.useState(()=>{
    const q=new URLSearchParams(location.search).get('variant')||window.PT_PICK_VARIANT;window.PT_PICK_VARIANT=null;
    const start=(q&&variants.find(v=>String(v.id)===String(q)&&v.available))||firstVar;
    return start?options.map((_,k)=>start.opts[k]):[];
  });
  const sizeLabel=PT_SIZE_LABEL[a.sizeTag]||'';
  const cur=(hasOpts&&variants.find(v=>options.every((_,k)=>v.opts[k]===sel[k])))||firstVar;
  const curOnSale=cur&&cur.compareAt>cur.price&&cur.price>0;
  const price=cur?cur.price:(a.salePrice||a.price);
  const compareAt=cur?(curOnSale?cur.compareAt:null):(a.salePrice?a.price:null);
  const soldOut=!!cur&&!cur.available;
  const variantId=(cur&&cur.id)||a.variantId||null;
  const valuesOf=k=>[...new Set(variants.map(v=>v.opts[k]).filter(Boolean))];
  // Only in-stock choices are shown. Out-of-stock sizes/colours stay in Shopify and reappear
  // by themselves once admin adds stock. A value shows if an in-stock variant has it together
  // with the choices made in the options above it (colour first, then size for that colour).
  const visibleValues=k=>valuesOf(k).filter(val=>variants.some(v=>v.available&&v.opts[k]===val&&options.every((_,j)=>j>=k||v.opts[j]===sel[j])));
  // Picking a value keeps the other choices if that combination is in stock; otherwise it
  // moves them to the first in-stock combination (e.g. new colour only has Medium).
  const pick=(k,val)=>setSel(s=>{
    const next=s.map((x,j)=>j===k?val:x);
    if(variants.some(v=>v.available&&options.every((_,j)=>v.opts[j]===next[j])))return next;
    const alt=variants.find(v=>v.available&&options.every((_,j)=>j>k||v.opts[j]===next[j]));
    return alt?options.map((_,j)=>alt.opts[j]):next;
  });

  // Photos: when photos are labelled with a colour (alt text in Shopify = colour name),
  // show only the chosen colour's photos plus any unlabelled/shared ones.
  const pics=[a.img,a.hoverImg,...(a.gallery||[])].map((src,t)=>({src,alt:(a.imageAlts||[])[t]||''})).filter(x=>x.src);
  const ci=hasOpts?options.findIndex(o=>PT_COLOUR_OPTION.test(o)):-1;
  const colourNames=ci>-1?valuesOf(ci):[];
  const byColour=ci>-1&&pics.some(x=>ptNamesColour(x.alt,colourNames));
  const images=(byColour?pics.filter(x=>ptPhotoMatches(x.alt,sel[ci],colourNames)):pics).map(x=>x.src);

  const[imgIdx,setImgIdx]=React.useState(0);
  const samePic=(x,y)=>!!x&&!!y&&x.split('?')[0].replace(/^https?:/,'')===y.split('?')[0].replace(/^https?:/,'');
  // New colour: start at its first photo; otherwise jump to the variant's own photo if it has one.
  React.useEffect(()=>{
    if(byColour){setImgIdx(0);return;}
    if(!cur||!cur.img)return;const k=images.findIndex(src=>samePic(src,cur.img));if(k>-1)setImgIdx(k);
  },[byColour?sel[ci]:(cur&&cur.id)]);
  const shownIdx=imgIdx<images.length?imgIdx:0;
  // After the page is idle: pre-load every colour's first photo and this colour's other photos
  // at display size, plus all thumbnails, so colour clicks and thumbnail clicks feel instant.
  React.useEffect(()=>{
    const MAIN=[600,900,1200,1600],SIZES='(max-width: 900px) 100vw, 50vw';
    const run=()=>{
      if(byColour)ptWarm(colourNames.map(c=>(pics.find(x=>ptNamesColour(x.alt,colourNames)&&ptPhotoMatches(x.alt,c,colourNames))||{}).src),MAIN,SIZES);
      ptWarm(images.slice(1),MAIN,SIZES);
      pics.forEach(x=>{const im=new Image();im.src=ptImgUrl(x.src,160);});
    };
    const idle=window.requestIdleCallback||(f=>setTimeout(f,1200)),cancel=window.cancelIdleCallback||clearTimeout;
    const id=idle(run);return()=>cancel(id);
  },[byColour?sel[ci]:0]);
  const[qty,setQty]=React.useState(1);
  const[openAcc,setOpenAcc]=React.useState('details');
  const[sizeHelp,setSizeHelp]=React.useState(false);
  // Size help shows for products that come in sizes or are worn (harness, collar, lead) or have a chart.
  const wearable=/harness|collar|lead|leash|vest|jacket|coat/i.test(str(a.name)+' '+str(a.type));
  const showSizeHelp=!!str(a.sizeChart)||wearable||options.some(o=>/size/i.test(o));
  React.useEffect(()=>{setOpenAcc('details');},[a.id]);

  // Ratings come only from the review_star / review_count metafields; hidden when not set.
  const rating=Number(a.rating)||0;
  const reviewCount=Number(a.reviewCount)||0;
  const hasRating=rating>0&&reviewCount>0;

  const displayReviews=a.reviews||[];

  const related=(d[i]||[]).filter(e=>e.id!==a.id).slice(0,4);
  const totalPrice=(price*qty).toFixed(0);

  const accordionItems=[
    {k:'details',label:'Product details',body:str(a.desc)||str(a.details)||'Quality materials built for comfort and durability.',rich:true},
    {k:'materials',label:'Materials and care',body:str(a.materials)||'Premium materials. Refer to product label for care instructions.'},
    {k:'shipping',label:'Shipping and returns',body:'Free delivery on orders above '+ptInr(ptFreeShipAt())+'. Dispatched the same day. 7-day returns on damaged, defective or incorrect items.'}
  ];

  function handleAdd(){
    if(soldOut)return;
    S({key:`${a.id}-${variantId||0}`,id:a.id,variantId:variantId,name:str(a.name),price:price,qty:qty,img:(cur&&cur.img)||images[0]||'',thumb:a.img||'',variantLabel:[hasOpts?cur.title:'',sizeLabel].filter(Boolean).join(' \u00B7 ')});
  }

  // Buy it now: Shopify cart permalink opens checkout with just this product
  // and quantity, leaving whatever is in the cart drawer untouched.
  const[buying,setBuying]=React.useState(false);
  React.useEffect(()=>{const f=()=>setBuying(false);window.addEventListener('pageshow',f);return()=>window.removeEventListener('pageshow',f);},[]);
  function handleBuyNow(){
    if(soldOut)return;
    if(!variantId){handleAdd();return;}
    setBuying(true);
    window.location.href='/cart/'+variantId+':'+qty;
  }

  // Price helpers for the size boxes: the price of a size with the other choices (colour) kept.
  const ptPct=(p,c)=>c>p&&p>0?Math.round((c-p)/c*100):0;
  const ptHasSizeOpt=hasOpts&&options.some(o=>!PT_COLOUR_OPTION.test(o)&&/size/i.test(o));
  const ptPriceFor=(k,val)=>{
    const m=variants.filter(v=>v.opts[k]===val&&options.every((_,j)=>j===k||v.opts[j]===sel[j]));
    const v=m.find(x=>x.available)||m[0]||variants.find(x=>x.opts[k]===val);
    return v?{price:v.price,compareAt:v.compareAt>v.price?v.compareAt:null}:{price,compareAt};
  };
  const shortDesc=str(a.tagline)||str(a.desc).replace(/<[^>]*>/g,'').slice(0,180)||'Quality product for your pet.';

  // Main gallery image is the page's LCP element: size it for its ~50vw box,
  // keep it eager with high fetch priority. Thumbs are tiny, so 160px is plenty.
  const mainImgProps=Object.assign(
    {className:'pdp-main-img-real',alt:str(a.name),style:{objectFit:'contain'},fetchPriority:'high',decoding:'async'},
    ptImgProps(images[shownIdx],[600,900,1200,1600],'(max-width: 900px) 100vw, 50vw')
  );
  delete mainImgProps.loading;

  return React.createElement('div',{className:'pdp'},
    React.createElement('div',{className:'crumb'},
      React.createElement('span',{onClick:()=>n({page:'home'}),style:{cursor:'pointer'}},'Home'),
      ' / ',
      React.createElement('span',{onClick:()=>n({page:'category',id:i}),style:{cursor:'pointer'}},str(c.name)),
      ' / ',
      React.createElement('span',null,str(a.name))
    ),
    React.createElement('div',{className:'pdp-grid pdp-grid-rich'},
      React.createElement('div',{className:'pdp-gallery'},
        images.length>1&&React.createElement('div',{className:'thumbs'},
          images.map((src,t)=>React.createElement('button',{
            key:t,
            className:'thumb-s '+(t===shownIdx?'active':''),
            onClick:()=>setImgIdx(t),
            'aria-label':'View image '+(t+1),
            style:{backgroundImage:'url('+ptImgUrl(src,160)+')',backgroundSize:'cover',backgroundPosition:'center'}
          }))
        ),
        // phones: swipe through the photos (snap), dots show which one; tiny thumbs + big image are desktop only
        images.length>0&&React.createElement('div',{className:'pdp-swipe'},
          React.createElement('div',{className:'pdp-swipe-track',onScroll:(e)=>{const el=e.currentTarget,k=Math.round(el.scrollLeft/el.clientWidth);if(k!==shownIdx&&k>=0&&k<images.length)setImgIdx(k);}},
            images.map((src,t)=>React.createElement('div',{key:t,className:'pdp-swipe-slide'},
              React.createElement('img',Object.assign({alt:str(a.name)+(t?' photo '+(t+1):''),decoding:'async'},ptImgProps(src,[450,700,1000],'100vw'),t===0?{loading:'eager',fetchPriority:'high'}:{loading:'lazy'}))))),
          images.length>1&&React.createElement('div',{className:'pdp-dots','aria-hidden':'true'},
            images.slice(0,12).map((_,t)=>React.createElement('i',{key:t,className:t===shownIdx?'on':''}))),
          images.length>1&&React.createElement('span',{className:'pdp-count'},(shownIdx+1)+' / '+images.length),
          soldOut&&React.createElement('span',{className:'pdp-sold-pill'},'Sold out')),
        React.createElement('div',{className:'main-img'},
          soldOut&&React.createElement('span',{className:'pdp-sold-pill'},'Sold out'),
          images.length>0
            ?React.createElement('img',mainImgProps)
            :React.createElement('div',{style:{color:'#aaa',fontSize:13,padding:60,textAlign:'center'}},'No image available'),
        )
      ),
      React.createElement('div',{className:'pdp-info'},
        // 1. category (link) + rating pill (jumps to the reviews)
        React.createElement('div',{className:'pdp-top'},
          React.createElement('button',{type:'button',className:'pdp-cat',onClick:()=>n({page:'category',id:i})},str(c.name),React.createElement('span',{'aria-hidden':'true'},' \u25b8')),
          React.createElement('span',{className:'pdp-top-right'},
          React.createElement(PtWishHeart,{id:a.id,name:str(a.name),className:'pdp-heart'}),
          hasRating&&React.createElement('button',{type:'button',className:'pdp-rate',onClick:()=>{const r=document.getElementById('pdp-reviews');if(r)r.scrollIntoView({behavior:'smooth',block:'start'});},'aria-label':'Rated '+rating+' out of 5 from '+reviewCount+' reviews. See reviews'},
            React.createElement('span',{className:'pdp-rate-star','aria-hidden':'true'},'\u2605'),rating,React.createElement('span',{className:'pdp-rate-n'},'('+reviewCount+')')))),
        // 2. name
        React.createElement('h1',null,window.PtAnnotate?React.createElement(window.PtAnnotate,{key:a.id,variant:'doubleUnderline',delay:0.25,duration:0.8},str(a.name)):str(a.name)),
        sizeHelp&&React.createElement(PtSizeHelp,{product:{name:str(a.name),sizeChart:str(a.sizeChart)},onClose:()=>setSizeHelp(false)}),
        // 3. options: colour as swatches, size as price boxes, anything else as pills
        hasOpts&&options.map((name,k)=>{
          const isColour=PT_COLOUR_OPTION.test(name),vals=visibleValues(k);
          if(!vals.length)return null;
          const isSize=!isColour&&/size/i.test(name);
          return React.createElement('div',{key:name,className:'pdp-opt'},
            React.createElement('div',{className:'pdp-opt-label'},name,': ',React.createElement('span',null,sel[k])),
            React.createElement('div',{className:isSize?'pdp-sizes':'pdp-opt-values',role:'radiogroup','aria-label':name},
              vals.map(val=>{
                const on=sel[k]===val;
                if(isColour)return React.createElement('button',{key:val,type:'button',role:'radio','aria-checked':on,'aria-label':val,title:val,
                    className:'pdp-swatch'+(on?' on':''),onClick:()=>pick(k,val)},
                    React.createElement('span',{style:{background:ptSwatchBg(val,a)}}));
                if(isSize){
                  const pv=ptPriceFor(k,val),off=ptPct(pv.price,pv.compareAt);
                  return React.createElement('button',{key:val,type:'button',role:'radio','aria-checked':on,className:'pdp-sizebox'+(on?' on':''),onClick:()=>pick(k,val)},
                    React.createElement('span',{className:'pdp-sizebox-head'},val),
                    React.createElement('span',{className:'pdp-sizebox-body'},
                      React.createElement('span',{className:'pdp-sz-price'},ptInr(pv.price),off>0&&React.createElement('span',{className:'pdp-sz-mrp'},' MRP ',React.createElement('s',null,ptInr(pv.compareAt)))),
                      off>0&&React.createElement('span',{className:'pdp-off'},off+'% OFF')));
                }
                return React.createElement('button',{key:val,type:'button',role:'radio','aria-checked':on,className:'pdp-pill'+(on?' on':''),onClick:()=>pick(k,val)},val);
              })
            )
          );
        }),
        // Size from the Shopify size tags ('Small Pets' / 'All Sizes') when there is no Size option.
        // Shown as one selected size box so every product reads the same way.
        sizeLabel&&!ptHasSizeOpt&&React.createElement('div',{className:'pdp-opt'},
          React.createElement('div',{className:'pdp-opt-label'},'Size: ',React.createElement('span',null,sizeLabel)),
          React.createElement('div',{className:'pdp-sizes'},
            React.createElement('div',{className:'pdp-sizebox on','aria-label':'Size '+sizeLabel},
              React.createElement('span',{className:'pdp-sizebox-head'},sizeLabel),
              React.createElement('span',{className:'pdp-sizebox-body'},
                React.createElement('span',{className:'pdp-sz-price'},ptInr(price),ptPct(price,compareAt)>0&&React.createElement('span',{className:'pdp-sz-mrp'},' MRP ',React.createElement('s',null,ptInr(compareAt)))),
                ptPct(price,compareAt)>0&&React.createElement('span',{className:'pdp-off'},ptPct(price,compareAt)+'% OFF'))))),
        // 4. size chart strip, below the sizes
        showSizeHelp&&React.createElement('button',{type:'button',className:'pdp-size-strip',onClick:()=>setSizeHelp(true)},
          'Refer ',React.createElement('u',null,'Size chart'),' for accurate measurements',React.createElement('span',{'aria-hidden':'true'},' \u203a')),
        // 5. price
        React.createElement('div',{className:'pdp-pricebox'},
          React.createElement('span',{className:'pdp-now'},ptInr(price)),
          compareAt&&React.createElement('span',{className:'pdp-mrp'},'MRP ',React.createElement('s',null,ptInr(compareAt))),
          ptPct(price,compareAt)>0&&React.createElement('span',{className:'pdp-offbig'},ptPct(price,compareAt)+'% OFF')),
        React.createElement('p',{className:'pdp-tax'},'Inclusive of all taxes'),
        // 6. buy
        React.createElement('div',{className:'pdp-atc-row'},
          React.createElement('div',{className:'qty'},
            React.createElement('button',{onClick:()=>setQty(q=>Math.max(1,q-1)),'aria-label':'Decrease quantity'},'-'),
            React.createElement('span',{className:'v'},qty),
            React.createElement('button',{onClick:()=>setQty(q=>q+1),'aria-label':'Increase quantity'},'+')
          ),
          React.createElement('div',{className:'pdp-atc-btns'},
            React.createElement('button',{className:'btn btn-primary'+(soldOut?' is-sold':''),onClick:handleAdd,disabled:soldOut},'Add to cart'),
            React.createElement('button',{className:'btn btn-outline pdp-buy-now'+(soldOut?' is-sold':''),onClick:handleBuyNow,disabled:buying||soldOut},buying?'Taking you to checkout\u2026':'Buy it now')
          )
        ),
        // phones: price + Add to cart always at the bottom of the screen (CSS shows it only on small screens)
        React.createElement('div',{className:'pdp-sticky',role:'region','aria-label':'Add to cart'},
          React.createElement('div',{className:'pdp-sticky-price'},
            React.createElement('strong',null,ptInr(price)),
            compareAt&&ptPct(price,compareAt)>0&&React.createElement('small',null,'MRP ',React.createElement('s',null,ptInr(compareAt)),' ',React.createElement('b',null,'('+ptPct(price,compareAt)+'% OFF)')),
            React.createElement('small',{className:'pdp-sticky-tax'},'Inclusive of all taxes')),
          React.createElement('button',{className:'btn btn-primary pdp-sticky-btn'+(soldOut?' is-sold':''),onClick:handleAdd,disabled:soldOut},'Add to cart')),
        // 7. two short offer lines, from the offer settings in Shopify
        React.createElement('ul',{className:'pdp-perks'},
          React.createElement('li',null,
            React.createElement('svg',{viewBox:'0 0 24 24',width:18,height:18,fill:'none',stroke:'currentColor',strokeWidth:1.8,strokeLinecap:'round',strokeLinejoin:'round','aria-hidden':'true'},React.createElement('path',{d:'M3 7h11v9H3zM14 10h4l3 3v3h-7zM7 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM17 19a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z'})),
            'Free delivery on orders above '+ptInr(ptFreeShipAt())),
          Number(PT_SETTINGS.bundleQty)>0&&Number(PT_SETTINGS.bundlePct)>0&&React.createElement('li',null,
            React.createElement('svg',{viewBox:'0 0 24 24',width:18,height:18,fill:'none',stroke:'currentColor',strokeWidth:1.8,strokeLinecap:'round',strokeLinejoin:'round','aria-hidden':'true'},React.createElement('path',{d:'M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8zM7.5 7.5h.01'})),
            'Buy '+Number(PT_SETTINGS.bundleQty)+', get '+Number(PT_SETTINGS.bundlePct)+'% off \u2014 applied automatically at checkout')),
        React.createElement('div',{className:'accordion'},
          accordionItems.map(item=>React.createElement('div',{key:item.k,className:'acc-item '+(openAcc===item.k?'open':'')},
            React.createElement('button',{className:'acc-head',onClick:()=>setOpenAcc(p=>p===item.k?null:item.k)},
              React.createElement('span',null,item.label),
              React.createElement(Icon.Chevron,null)
            ),
            item.rich?React.createElement('div',{className:'acc-body'},React.createElement(PtProductDetails,{key:a.id,html:item.body}))
              :React.createElement('div',{className:'acc-body',dangerouslySetInnerHTML:{__html:item.body}})
          ))
        )
      )
    ),
    (hasRating||displayReviews.length>0)&&React.createElement('section',{className:'pdp-block',id:'pdp-reviews'},
      React.createElement('div',{className:'pdp-block-head'},
        React.createElement('h2',{className:'section-title'},'Customer ',React.createElement('em',null,'Reviews'))
      ),
      React.createElement('div',{className:'pdp-reviews'},
        hasRating&&React.createElement('div',{className:'review-summary'},
          React.createElement('div',{className:'review-score'},rating),
          React.createElement('div',{className:'review-stars'},
            React.createElement(Icon.Star,null),React.createElement(Icon.Star,null),
            React.createElement(Icon.Star,null),React.createElement(Icon.Star,null),
            React.createElement(Icon.Star,null)
          ),
          React.createElement('p',null,'Based on '+reviewCount+' verified ratings')
        ),
        displayReviews.length>0&&React.createElement('div',{className:'review-list'},
          displayReviews.map((r,t)=>React.createElement('article',{key:t,className:'review-card'},
            React.createElement('div',{className:'review-stars'},
              Array.from({length:r.stars||5}).map((_,m)=>React.createElement(Icon.Star,{key:m}))
            ),
            React.createElement('h4',null,str(r.title)),
            React.createElement('p',null,str(r.body)),
            str(r.name)&&React.createElement('span',null,str(r.name))
          ))
        )
      )
    ),
    related.length>0&&React.createElement('section',{className:'section',style:{padding:'80px 0 0'}},
      React.createElement('div',{className:'section-head'},
        React.createElement('h2',{className:'section-title'},'You may ',React.createElement('em',null,'also like')),
        React.createElement('span',{className:'link-arrow',onClick:()=>n({page:'category',id:i})},'Shop ',str(c.name),' ',React.createElement(Icon.ArrowRight,null))
      ),
      React.createElement('div',{className:'product-grid'},
        related.map(e=>React.createElement(ProductCard,{key:e.id,p:e,onClick:()=>n({page:'pdp',id:e.id,category:i})}))
      )
    )
  );
}
class _B extends React.Component{
  constructor(p){super(p);this.state={err:null};}
  static getDerivedStateFromError(e){return{err:e};}
  render(){
    if(this.state.err){
      const e=this.state.err;
      return React.createElement('div',{style:{padding:'40px 24px',margin:'24px',background:'#fff3cd',border:'2px solid #f0a500',borderRadius:10,fontFamily:'monospace',fontSize:13,lineHeight:1.8}},
        React.createElement('b',null,'PDP crashed:'),
        React.createElement('br',null),
        React.createElement('span',null,'Error: '+e.message),
        React.createElement('br',null),
        React.createElement('pre',{style:{fontSize:11,whiteSpace:'pre-wrap',marginTop:8}},(e.stack||'').slice(0,800))
      );
    }
    return this.props.children;
  }
}
// key: a new product gets fresh state (chosen colour, photo, quantity).
window.PDP=function(p){return React.createElement(_B,null,React.createElement(PDPInner,Object.assign({key:p.id},p)));};
